export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'AiVM2eM9DPmHsHXOtcAWl8exfZn8cwzN',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'AiVM2eM9DPmHsHXOtcAWl8exfZn8cwzN',
        audience: 'https://crew-time/api',
    }
}